import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export const exportPlanwisePDF = (planwiseData) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text("Plan-wise Customer Report", 14, 20);

  let currentY = 30;

  planwiseData.forEach((planGroup) => {
    // Check for page overflow
    if (currentY > 240) {
      doc.addPage();
      currentY = 20;
    }

    // Plan Title
    doc.setFontSize(14);
    doc.setTextColor(41, 128, 185);
    doc.text(`${planGroup.plan_name} Plan`, 14, currentY);
    currentY += 8;

    // --- SUMMARY ROW FOR PDF ---
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Total: ${planGroup.total_boxes} Boxes `, 14, currentY);
    currentY += 5;

    const tableData = planGroup.data.map((cust, index) => [
      index + 1,
      cust.customer_no,
      cust.name,
      cust.area_name,
      cust.plan_prize,
      cust.staff_name,
     cust.total_collection_amount,cust.total_pending_amount
    ]);

    autoTable(doc, {
      head: [
        [
          "S.No",
          "Customer No",
          "Name",
          "Area",
          "Plan Prize",
          "Staff",
          "Total Collection",
          "Pending Amount",
        ],
      ],
      body: tableData,
      startY: currentY,
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    currentY = doc.lastAutoTable.finalY + 15;
  });

  doc.save(`Plan_Report_${new Date().toLocaleDateString()}.pdf`);
};

export const exportPlanwiseExcel = (planwiseData) => {
  const wb = XLSX.utils.book_new();
  const flattenedData = [];

  flattenedData.push({ "S.No": "PLAN-WISE REPORT" }); // Main Title

  planwiseData.forEach((planGroup) => {
    // 1. Add Plan Header with Summary
    flattenedData.push({
      "S.No": `PLAN: ${planGroup.plan_name.toUpperCase()}`,
      "Customer No": `Total: ${planGroup.total_boxes}`,
     
     
    });

    // 2. Add Column Sub-headers for readability
    flattenedData.push({
      "S.No": "S.No",
      "Customer No": "Cust No",
      "Customer Name": "Name",
      Area: "Area",
      "Plan Prize": "Plan Prize",
      Staff: "Staff",
      "Total Collection": "Total Collection",
      "Pending Amount": "Pending Amount",
    });

    // 3. Add Customer Rows
    planGroup.data.forEach((cust, index) => {
      flattenedData.push({
        "S.No": index + 1,
        "Customer No": cust.customer_no,
        "Customer Name": cust.name,
        Area: cust.area_name,
        "Prize": cust.plan_prize,
        Staff: cust.staff_name,
        "Total Collection": cust.total_collection_amount,
        "Pending Amount": cust.total_pending_amount,
     
      });
    });

    flattenedData.push({}); // Empty row spacer
  });

  const ws = XLSX.utils.json_to_sheet(flattenedData, { skipHeader: true });
  XLSX.utils.book_append_sheet(wb, ws, "Planwise Report");
  XLSX.writeFile(wb, `Plan_Report_${new Date().toLocaleDateString()}.xlsx`);
};
